try {

    // IDs of divs that display Instance ID token UI or request permission UI.


    // // [START refresh_token]
    // // Callback fired if Instance ID token is updated.
    // front_messaging.onTokenRefresh(() => {
    //   front_messaging.getToken().then((refreshedToken) => {
    //     consoleLog('Token refreshed.');
    //     // Indicate that the new Instance ID token has not yet been sent to the
    //     // app server.
    //     setTokenSentToServer(false);
    //     // Send Instance ID token to app server.
    //     sendTokenToServer(refreshedToken);
    //     // [START_EXCLUDE]
    //     // Display new Instance ID token and clear UI of all previous messages.
    //     getFcmToken();
    //     // [END_EXCLUDE]
    //   }).catch((err) => {
    //     consoleLog('Unable to retrieve refreshed token ', err);
    //     showToken('Unable to retrieve refreshed token ', err);
    //   });
    // });
    // // [END refresh_token]


    // [START receive_message]
    // Handle incoming messages. Called when:
    // - a message is received while the app has focus
    // - the user clicks on an app notification created by a service worker
    //   `front_messaging.setBackgroundMessageHandler` handler.
    front_messaging.onMessage((payload) => {
        consoleLog('Message received. ', payload);
        // [START_EXCLUDE]
        // Update the UI to include the received message.
        if (payload.data.type == 'user') {

            updateUnreadCount();
            showMessage(payload);
        }
        // [END_EXCLUDE]
    });
    // [END receive_message]


    getFcmToken = function (registration) {
        showToken('loading...');
        // [START get_token]
        // Get Instance ID token. Initially this makes a network call, once retrieved
        // subsequent calls to getToken will return from cache.
        front_messaging.getToken({
            vapidKey: firebaseConfig_front.vapidKey,  // Required here in the options
            serviceWorkerRegistration: registration
        }).then((currentToken) => {
            consoleLog('getToken', currentToken)
            if (currentToken && $('#notifications_user_id').val()) {
                sendTokenToServer(currentToken);
            } else {
                // Show permission request.
                consoleLog('No Instance ID token available. Request permission to generate one.');
                // Show permission UI.
                // requestPermission();
                setTokenSentToServer(false);
            }
        }).catch((err) => {

            consoleLog('An error occurred while retrieving token. ', err);
            showToken('Error retrieving Instance ID token. ', err);
            setTokenSentToServer(false);
        });
        // [END get_token]
    }


    showToken = function (currentToken) {
        // Show token in console and UI.
        consoleLog('showToken ', currentToken);
    }

    // Send the Instance ID token your application server, so that it can:
    // - send messages back to this app
    // - subscribe/unsubscribe the token from topics
    sendTokenToServer = function (currentToken) {
        if (!isTokenSentToServer(currentToken)) {
            consoleLog('Sending token to server...' + currentToken);

            let form_data = new FormData();
            form_data.append('token', currentToken);
            form_data.append('type', 'web');
            $.ajax({
                url: shopBaseUrl + "/notifications/fcm/token/store",
                type: 'POST',
                cache: false,
                contentType: false,
                processData: false,
                data: form_data,
                success: function (result) {
                    consoleLog('result', result);
                    if (result.status) {
                        setTokenSentToServer(currentToken);
                    }
                },
                error: function () {

                }
                ,
                beforeSend: function (xhr) {
                    unBlockPage();

                }
            });
        } else {
            consoleLog('Token already sent to server so won\'t send it again ' +
                'unless it changes.' + currentToken);
        }

    }

    isTokenSentToServer = function (token) {
        return window.localStorage.getItem('sentToServer') === token;
    }

    setTokenSentToServer = function (token) {
        if (token) {
            window.localStorage.setItem('sentToServer', token);

        }
    }


    requestPermission = function () {
        consoleLog('Requesting permission...');
        // [START request_permission]
        Notification.requestPermission().then((permission) => {
            if (permission === 'granted') {
                consoleLog('Notification permission granted.');
                navigator.serviceWorker.ready.then((registration) => {
                    getFcmToken(registration);
                });

                // [END_EXCLUDE]
            } else {
                consoleLog('Unable to get permission to notify.');
            }
        });
        // [END request_permission]
    }


    showMessage = function (payload) {
        consoleLog('showMessage', payload);
        var toast = toastr.info(payload.notification.body, payload.notification.title);

        /* you can also use toastr here */
    }


    updateUnreadCount = function () {
        let current_count = $('#header_notifications_count_home').text();
        if (isNaN(current_count)) current_count = 0;
        current_count = parseInt(current_count);
        $('#header_notifications_count_home').text(current_count + 1);
    }

    navigator.serviceWorker.register("/firebase-messaging-sw.js?v=2.0")
        .then((registration) => {
            consoleLog("Service Worker registered:", registration);
            getFcmToken(registration);
        });

    // getFcmToken();
// requestPermission();


} catch (error) {

}
